import { baseApi } from "../baseApi";

export const WaadApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // CREATE
    createWaad: builder.mutation({
      query: (data) => ({
        url: "/waad",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }),
      invalidatesTags: ["Waad"],
    }),

    // GET ALL
    getWaad: builder.query({
      query: ({
        page = 1,
        limit = 10,
        search = "",
        status = "",
      } = {}) =>
        `/waads?page=${page}&limit=${limit}&search=${search}&status=${status}`,
      providesTags: ["Waad"],
    }),

    // GET SINGLE
    getSingleWaad: builder.query({
      query: (id) => `/waad/${id}`,
      providesTags: (result, error, id) => [{ type: "Waad", id }],
    }),

    // GET WAAD WITH GAONS
    getWaadWithGaons: builder.query({
      query: (id) => `/waad-gaons/${id}`,
      providesTags: (result, error, id) => [{ type: "Waad", id }],
    }),

    // ✅ GET WAAD DROPDOWN - ADD THIS
    getWaadDropdown: builder.query({
      query: () => `/waads-dropdown`,
      providesTags: ["Waad"],
    }),

    // UPDATE
    updateWaad: builder.mutation({
      query: (data) => ({
        url: `/waad/${data.id}`,
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }),
      invalidatesTags: ["Waad"],
    }),

    // STATUS CHANGE
    changeStatusWaad: builder.mutation({
      query: ({ id, status }) => ({
        url: `/waad-status/${id}`,
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ status }),
      }),
      invalidatesTags: ["Waad"],
    }),

    // DELETE
    deleteWaad: builder.mutation({
      query: (data) => ({
        url: `/waad/${data.id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Waad"],
    }),
  }),
});

export const {
  useCreateWaadMutation,
  useGetWaadQuery,
  useGetSingleWaadQuery,
  useGetWaadWithGaonsQuery,
  useGetWaadDropdownQuery, // ✅ ADD THIS EXPORT
  useUpdateWaadMutation,
  useChangeStatusWaadMutation,
  useDeleteWaadMutation,
} = WaadApi;